import { Button } from "@mui/material";
import { ReactComponent as ArrowRightIcon } from "../../../../../common/icons/arrows-right-filled.svg";
import { ReactComponent as ArrowRightGrayIcon } from "../../../../../common/icons/arrows-right-filled-gray.svg";

type Props = {
  onClick: () => void;
  label: string;
  disabled?: boolean;
};

const SearchOtherTalentsButton = ({
  onClick,
  label,
  disabled = false,
}: Props) => {
  return (
    <Button
      onClick={onClick}
      endIcon={!disabled ? <ArrowRightIcon /> : <ArrowRightGrayIcon />}
      disabled={disabled}
    >
      {label}
    </Button>
  );
};

export default SearchOtherTalentsButton;
